import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  DialogTitle,
  Dialog,
  Divider,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
} from "@mui/material";
import { useCreate } from "@refinedev/core";
type TO_NOTIFY_USER_TYPE = "FOLLOWERS" | "CONTRIBUTORS" | "AUTHORIZED";

const NotifyUserModal: React.FC<{
  open: boolean;
  onClose: () => void;
  grantvestmentId: number;
  grantvestmentName: string;
}> = ({ open, onClose, grantvestmentId, grantvestmentName }) => {
  const [inputValue, setInputValue] =
    useState(`A new update for your GrantVestment ${grantvestmentName} has been uploaded.
To access it, find this GrantVestment under My GrantVestments, and go the Updates page.`);
  const [types, setTypes] = React.useState<TO_NOTIFY_USER_TYPE[]>([
    "FOLLOWERS",
    "CONTRIBUTORS",
  ]);
  const notifyUser = useCreate();
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = () => {
    notifyUser.mutate(
      {
        resource: "grantvestment-follower/notify-followers",
        values: {
          content: inputValue,
          grantvestmentId: grantvestmentId,
          followers: types.includes("FOLLOWERS") ? true : false,
          authorized: types.includes("AUTHORIZED") ? true : false,
          contributors: types.includes("CONTRIBUTORS") ? true : false,
        },
      },
      {
        onSuccess: () => {
          setInputValue("");
          onClose();
        },
      }
    );
  };
  const handleTypeChange = (type: TO_NOTIFY_USER_TYPE) => {
    setTypes((prev) => {
      const index = prev.findIndex((item) => item === type);
      let filterTypes = [];

      if (index !== -1) {
        filterTypes = [...prev];
        filterTypes.splice(index, 1);
      } else {
        filterTypes = [...prev, type];
      }
      return filterTypes;
    });
  };
  const TO_NOTIFY_USER_TYPE_VALUES: TO_NOTIFY_USER_TYPE[] = [
    "FOLLOWERS",
    "CONTRIBUTORS",
    "AUTHORIZED",
  ];
  const typesFilter = TO_NOTIFY_USER_TYPE_VALUES.map((type) => ({
    title: type,
    status: type,
  }));
  const contains = (type: TO_NOTIFY_USER_TYPE) => {
    return types.includes(type);
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle color="primary">
        Notify followers with the latests update
      </DialogTitle>
      <Divider />

      <DialogContent>
        <Typography variant="bodyCopyRegular" sx={{ mb: 1 }}>
          Select the type of users to notify
        </Typography>
        <Grid sx={{ my: 2 }} container spacing={0.5}>
          {typesFilter.map((item, index) => {
            return (
              <Grid key={index} item>
                {contains(item.status as TO_NOTIFY_USER_TYPE) ? (
                  <Button
                    key={index}
                    onClick={() =>
                      handleTypeChange(item.status as TO_NOTIFY_USER_TYPE)
                    }
                    variant={"contained"}
                    color="primary"
                    size="large"
                  >
                    {item.title}
                  </Button>
                ) : (
                  <Button
                    key={index}
                    onClick={() =>
                      handleTypeChange(item.status as TO_NOTIFY_USER_TYPE)
                    }
                    variant={"outlined"}
                    color="primary"
                    size="large"
                  >
                    {item.title}
                  </Button>
                )}
              </Grid>
            );
          })}
        </Grid>
        <Typography variant="bodyCopyRegular" sx={{ mb: 1 }}>
          Enter the email content{" "}
        </Typography>
        <Box>
          <TextField
            fullWidth
            label="Enter your message"
            variant="outlined"
            value={inputValue}
            onChange={handleInputChange}
            sx={{ my: 2 }}
            multiline={true}
            rows={3}
          />
        </Box>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!inputValue || notifyUser.isLoading}
          >
            {notifyUser.isLoading ? "Sending..." : "Send"}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={notifyUser.isLoading}
            onClick={() => {
              setInputValue("");
              onClose();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default NotifyUserModal;
